
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { APP_FIELD_SX, APP_UI } from "../ui/appUi";

export default function AppSearchField({ label = "Suche", value, onChange, placeholder, autoFocus = false }: {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  return (
    <TextField
      autoFocus={autoFocus}
      fullWidth
      label={label}
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      autoComplete="off"
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: { autoComplete: "off", autoCorrect: "off", spellCheck: false },
        input: {
          startAdornment: <InputAdornment position="start"><SearchRoundedIcon sx={{ color: APP_UI.accent }} /></InputAdornment>,
          endAdornment: value ? <InputAdornment position="end"><IconButton onClick={() => onChange("")} edge="end" aria-label="Suche leeren" sx={{ color: "rgba(255,255,255,.8)" }}><ClearRoundedIcon /></IconButton></InputAdornment> : undefined,
        },
      }}
      sx={APP_FIELD_SX}
    />
  );
}
